import React from 'react';
import { Pressable, StyleSheet, } from 'react-native';
import { Text } from '@rneui/themed';
export const Info = ({ name = '', onPress = () => { }, style = {}, }) => {
    return (React.createElement(Pressable, { style: styles.titleTouchable, onPress: onPress },
        React.createElement(Text, { h4: true, style: StyleSheet.flatten([
                styles.trackTitle,
                style,
            ]), numberOfLines: 1 }, name)));
};
const styles = StyleSheet.create({
    trackTitle: {
        paddingRight: 15,
        paddingHorizontal: 10
    },
    titleTouchable: {
        height: '100%',
        justifyContent: 'center',
    },
});
//# sourceMappingURL=Info.js.map